import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/mensajeria/components/MensajeriaAccordions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/mensajeria/components/PropuestaForm.tsx");
